import { Component, OnInit } from '@angular/core'
import { first } from 'rxjs'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { ModalController } from '@ionic/angular'
import { Storage } from '@ionic/storage'
import { environment } from 'src/environments/environment'
import { AlertService } from '@services/utils/alerts/alert.service'
import { ValidationService } from '@services/utils/validations/validation.service'
import { AddressService } from '@services/catalogs/address/address.service'
import { ValidationMessages } from '@services/utils/validations/validation-messages.service'
import { EndpointsService } from '@services/api/endpoints.service'
import { ApiService } from '@services/api/api.service'

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.page.html',
  styleUrls: ['./create-address.page.scss']
})
export class CreateAddressPage implements OnInit {
  createForm: FormGroup
  address = []
  userInfo
  addressRegister: any
  title: string = 'La dirección'
  validationMessages = this.validationMessagesLoad.validationMessages
  currentCharCount: number = 0

  userStorage_ID = 0
  idAddress = -1

  id_country
  states = []
  cities = []
  institutions = []
  status_city: boolean = true
  statusForm = false

  filteredOptions: string[] = []
  filteredOptionsInstitutions: string[] = []

  url = this.endpointsService.url

  constructor(
    public endpointsService: EndpointsService,
    public apiService: ApiService,
    public alertService: AlertService,
    public addressService: AddressService,
    public validationMessagesLoad: ValidationMessages,
    public validationService: ValidationService,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    public storage: Storage
  ) {}

  ngOnInit() {
    this.validateForm()
    this.getDataUser()
    this.storage.get(environment.localStorage).then((user) => {
      if (user != null) {
        this.loadStates(user.country_name)
      }
    })
    this.updateCharCount()
  }

  onChangeInstitution(event): void {
    this.filteredOptionsInstitutions = this.institutions
      .filter((institution) => {
        return (
          institution.name
            .toLowerCase()
            .indexOf(event.target.value.toLowerCase()) > -1
        )
      })
      .map((institution) => {
        return institution.name
      })
  }

  loadStates(country_name) {
    this.states = []
    this.apiService
      .getAll(this.url.state)
      .pipe(first())
      .subscribe(
        (res) => {
          this.states = res.filter((obj) => {
            return obj.active && obj.country_name == country_name
          })
        },
        (err) => {}
      )
  }

  loadCities() {
    let data = this.createForm.controls
    let state = data.state_id.value.id
    this.createForm.get('city_id').enable()
    this.createForm.controls['city_id'].setValue('')

    this.apiService
      .getAll(this.url.city)
      .pipe(first())
      .subscribe(
        (res) => {
          this.cities = res.filter((obj) => {
            return obj.active && obj.state_id == state
          })
          this.status_city = false
        },
        (err) => {}
      )
  }

  async create() {
    if (!this.createForm.valid) {
      this.createForm.markAllAsTouched()
      this.alertService.errorFields()
    } else {
      this.alertService.presentLoading()

      await this.addressService
        .create(this.getData())
        .pipe(first())
        .subscribe(
          (res) => {
            this.alertService.dismiss().then(() => {
              this.success(res)
              this.idAddress = res.id
              this.closeModal()
            })
          },
          (err) => {
            this.alertService.dismiss().then(() => {
              this.alertService.statusErrorUpdate(err)
              this.closeModal()
            })
          }
        )
    }
  }

  getDataUser() {
    this.storage.get(environment.localStorage).then((data) => {
      if (data != null) {
        this.userInfo = data
      }
    })
  }

  getData = function () {
    let data = this.createForm.controls
    this.addressRegister = {
      identification_user: this.userInfo.email,
      state_id: data.state_id.value.id,
      city_id: data.city_id.value.id,
      institution_name: data.institution.value,
      address: data.address.value,
      observation: data.observation.value,
      postal: data.postal.value
    }

    return this.addressRegister
  }

  success(res) {
    this.alertService.statusSuccessRegister(this.title)
  }

  closeModal() {
    this.modalController.dismiss(
      this.idAddress != -1 ? this.idAddress : undefined
    )
  }

  validateForm() {
    this.createForm = this.formBuilder.group({
      address: ['', [this.validationService.Validation(3, 51, 'anyText')]],
      observation: [
        '',
        [this.validationService.Validation(3, 201, 'anyText', false)]
      ],
      state_id: ['', Validators.compose([Validators.required])],
      city_id: [
        {
          value: '',
          disabled: true
        },
        Validators.compose([Validators.required])
      ],
      institution: ['', [this.validationService.Validation(3, 51, 'anyText')]],
      postal: [
        '',
        [this.validationService.Validation(3, 9, 'onlyNumbersText', false)]
      ]
    })
  }

  updateCharCount() {
    const observationValue = this.createForm?.get('observation')?.value || '';
    this.currentCharCount = observationValue.length;
  }

  get errorControl() {
    return this.createForm.controls
  }
}
